<template>
<div class="chapter">
<div class="inner_page">
<div class="maps" id="maps">
<h2 class="contentsHead">Maps</h2>
<p class="contentsEntry"><span href="#/OnceAMarine_chapter5001#map1" title="Link target outside of Sample">The First Gulf War</span></p>
<p class="contentsEntry"><span href="#/OnceAMarine_chapter5501#map2" title="Link target outside of Sample">Operation Iraqi Freedom</span></p>
<p class="contentsEntry"><span href="#/OnceAMarine_chapter6001#map3" title="Link target outside of Sample">The Battle of Fallujah</span></p>
<h2 class="contentsHead">Photos</h2>
<p class="contentsEntry"><a href="#/OnceAMarine_dedication#nick">Frontis Gunny Sergeant Nick Popaditch and his wife April</a></p>
<p class="contentsEntry"><span href="#/OnceAMarine_chapter3201#gallery" title="Link target outside of Sample">A gallery of photos</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// OnceAMarine_Maps.vue?eecadee6